export const numberAlignRight = () => ({
  style: {
    textAlign: 'right',
  },
})

export const textBreakWord = (_, rowInfo) => ({
  style: {
    whiteSpace: rowInfo && 'normal',
    wordBreak: rowInfo && 'break-word',
  },
})
